module.exports = __webpack_public_path__ + "i18n/fr.69693bc745ebcd49569319e069d5af23.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 1539
// module chunks = 60